import { render, staticRenderFns } from "./CartStep4.vue?vue&type=template&id=21ea5500&scoped=true&"
import script from "./CartStep4.vue?vue&type=script&lang=js&"
export * from "./CartStep4.vue?vue&type=script&lang=js&"
import style0 from "./CartStep4.vue?vue&type=style&index=0&id=21ea5500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea5500",
  null
  
)

export default component.exports